import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const BASE = "/api/v1/erp/barcode-patterns";

export const fetchBarcodePatterns = createAsyncThunk(
  "barcodePattern/fetch",
  async (params?: string): Promise<any> => {
    const query = params ? `?${params}` : "";
    const response = await axios.get(`${BASE}${query}`);
    return response.data;
  }
);

export const createBarcodePattern = createAsyncThunk(
  "barcodePattern/create",
  async (payload: any): Promise<any> => {
    const response = await axios.post(BASE, payload);
    return response.data;
  }
);

export const updateBarcodePattern = createAsyncThunk(
  "barcodePattern/update",
  async ({ id, payload }: { id: string; payload: any }): Promise<any> => {
    const response = await axios.put(`${BASE}/${id}`, payload);
    return response.data;
  }
);

export const deleteBarcodePattern = createAsyncThunk(
  "barcodePattern/delete",
  async (id: string): Promise<any> => {
    const response = await axios.delete(`${BASE}/${id}`);
    return response.data;
  }
);
